export const DAY_HOURS = 24;
export const MAX_DAY_CHIP_VALUE = 10;
